import { render, staticRenderFns } from "./Key.vue?vue&type=template&id=27a9208e&scoped=true&"
import script from "./Key.vue?vue&type=script&lang=js&"
export * from "./Key.vue?vue&type=script&lang=js&"
import style0 from "./Key.vue?vue&type=style&index=0&id=27a9208e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9208e",
  null
  
)

export default component.exports